import { createContext, useEffect, useState } from "react";
import { Button, Container, Row, Col, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import MemberPanelAuth from "../../Utilities/MemberPanelAuth";
import { BsArrowRightCircleFill } from "react-icons/bs";
import { createDonationPaymentOrderAction, getMemberProfileAction } from "../../Redux/Action/MemberProfileAction";
import { useRazorpay } from "react-razorpay";
import { ToastContainer } from "react-toastify";
export const MemberProfileContext = createContext();


function MemberPanelDashboardComponent(props) {
  const dispacth = useDispatch()
  const { Razorpay } = useRazorpay();
  //state
  const [memberData, setMemberData] = useState({})
  const memberDetails = localStorage.getItem("member_detail", JSON.stringify("member_detail"))
  const memberId = JSON.parse(memberDetails).id
  const [forceToFetchData, setForceToFetchData] = useState(false)

  // console.log(memberData)

  // lifecercle
  useEffect(() => {
    const payload = {
      data: { member_id: memberId },
      setMemberData,
    };
    console.log("fetch called")
    dispacth(getMemberProfileAction(payload))

  }, [forceToFetchData])

  // total payed calculation
  const totalPayedAmount = () => {
    try {
      let total = 0
      memberData?.user_collection_histories.map(d => {
        total += d.collection_amount
      })
      return total
    } catch (error) {
      return 0
    }
  }


  // ✅ PRODUCTION MODE — Create order from backend
  const handleRealPayment = async (data) => {
    const current_pay_btn = document.getElementById(`pay-btn-${data.index}`)
    current_pay_btn.disabled = true
    // making payload
    const payload = {
      data: {
        amount: data.amount,
        year: data.year,
        member_name: data.member_name,
        mobile: data.mobile,
        agent_id: data.agent_id,
        email: data?.email
      },
      Razorpay,
      current_pay_btn
    }
    dispacth(createDonationPaymentOrderAction(payload))
  };
  return (
    <>
      <MemberProfileContext.Provider value={{
        memberData, setMemberData
      }}>
        <Container className="mt-5">
          <Row className="justify-content-center">
            <Col lg={6} md={6} sm={12}>
              <Card>
                <Card.Body>
                  {/* <button onClick={e => {
                    try {
                      document.getElementById(`pay-btn-${0}`).disabled = true
                    } catch (error) {

                    }
                  }}>test</button>

                  <button onClick={e => {
                    try {
                      setForceToFetchData(prev => !prev)
                    } catch (error) {

                    }
                  }}>test</button> */}
                  <Card.Text >

                    <div className="d-flex justify-content-between align-items-center">
                      <div><Card.Title className="memberTitle"> {memberData.member_name}</Card.Title></div>
                      <div>
                        <div className="totalPayment">
                          <h5>Total Payed</h5>{totalPayedAmount()}
                        </div>
                        <div className="totalPayment"><h5>Total Due</h5>{memberData?.member_due_profile?.total_due || 0}/-</div>
                        <Button
                          onClick={() => {
                            MemberPanelAuth.logout();
                          }}
                        >
                          Logout
                        </Button></div>

                    </div>
                    <div className="memberDetails">
                      <ul>
                        <li>Id  <strong>{memberData.id}</strong></li>
                        <li>Guardian Name  <strong>{memberData.guardian_name}</strong></li>
                        <li>Mobile <strong>{memberData.mobile}</strong></li>

                        <li>Yearly donation amount <strong>{memberData.yearly_donation_amount || "N/A"}</strong> </li>
                        <li>Start Year <strong>{memberData.start_year || "N/A"}</strong> </li>

                      </ul>
                      <ul className="paymentTable">
                        {memberData?.user_collection_histories?.map((singleCollection, index) => (
                          <li key={index}>
                            {singleCollection.collection_year}<strong>{singleCollection.collection_amount}</strong>
                          </li>
                        ))}

                      </ul>
                      <ul className="paymentTable">
                        {memberData?.member_due_profile?.unpaid_years?.map((singleDue, index) => (
                          <li key={index}>
                            {singleDue}<strong><button id={`pay-btn-${index}`} onClick={e => { handleRealPayment({ agent_id: memberData?.agent?.id, amount: memberData.yearly_donation_amount, year: singleDue, member_name: memberData?.member_name, mobile: memberData?.mobile, email: "machhumeebaidya@gmail.com", index }) }} className="payNow">Pay Now {memberData.yearly_donation_amount} ₹ <BsArrowRightCircleFill /></button></strong>
                          </li>
                        ))}

                      </ul>
                    </div>
                  </Card.Text>


                </Card.Body>
                <Card.Footer>
                  <strong>Agent name</strong>:{memberData?.agent?.full_name}<br />
                  <strong>Agent Phone </strong>: {memberData?.agent?.mobile || "N/A"} <br />
                </Card.Footer>
              </Card>
            </Col>
          </Row>

          <ToastContainer />
        </Container>
      </MemberProfileContext.Provider>

    </>
  );
}

export default MemberPanelDashboardComponent;
